import { render, staticRenderFns } from "./LmsUserProfile.vue?vue&type=template&id=48941f7d&scoped=true"
import script from "./LmsUserProfile.vue?vue&type=script&lang=js"
export * from "./LmsUserProfile.vue?vue&type=script&lang=js"
import style0 from "./LmsUserProfile.vue?vue&type=style&index=0&id=48941f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48941f7d",
  null
  
)

export default component.exports